import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';
import { EmployeeResponse } from 'src/app/models/employee.model';
import { HumanResourcesService } from 'src/app/services/human-resources.service';
import { PayrollService } from 'src/app/services/payroll.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ProfileSalaryRequest } from 'src/app/models/profile-salary.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { RolesAndPermissionsService } from 'src/app/services/roles-and-permissions.service';

@Component({
  selector: 'app-employee-active-list',
  templateUrl: './employee-active-list.component.html',
  styleUrls: ['./employee-active-list.component.scss']
})
export class EmployeeActiveListComponent implements OnInit {
  permissionType = PermissionTypeEnum;
  employees: EmployeeResponse [] = [];
  employeesFilter: EmployeeResponse [] = [];
  pagination = {
    total: [],
    filter: [],
    pageSize: 5,
    pageIndex: 0,
    startElement: 0,
    lastElement: 0
  };
  deleting: { [key: string]: boolean } = {};
  waitingFor = null;
  seeEmployeeTermination = false;

  selectedProfile: any = null;
  employeeToUpdateContract: any = null;

  contractProfiles: any[] = [];
  positions: any[] = [];

  selectedPosition: any = null;

  updatingContract = false;
  updatingContractEmployee = false;

  createProfileSalary = false;
  newSalary: ProfileSalaryRequest = null;

  terminationDate: string = new Date().toISOString().split('T')[0];
  
  
  constructor(
    private toastService: ToastrService,
    private humanResourcesService: HumanResourcesService,
    private payrollService: PayrollService,
    private roleService: RolesAndPermissionsService
  ) { }

  ngOnInit(): void {
    this.getEmployees();
    this.setProfileContracts(null);
    this.setAllPositions();
  }

  setProfileContracts(idSelected: number) {
    this.humanResourcesService.getProfileContract().subscribe({
      next: (response: ResponseObject) => {
        this.contractProfiles = response.data || [];

        if (idSelected) {
          this.selectedProfile = idSelected;
        }
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error?.message || 'Error al cargar perfiles');
      }
    });
  }

  setAllPositions() {
    this.roleService.getPositions().subscribe({
      next: (response: ResponseObject) => {
        this.positions = response.data || [];
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error?.message || 'Error al cargar posiciones');
      }
    });
  }

  getEmployees() {
    this.payrollService.getContractedData().subscribe({
      next: (response: any) => {
        this.employees = response.data;
        this.pagination.total = this.employees;
        this.resetPagination();
        this.filter();
      },
      error: (error) => {
        this.toastService.error('Error al cargar los empleados', 'Error');
      }
    });
  }

  resetPagination() {
    this.pagination.pageIndex = 0;
    this.pagination.startElement = 0;
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.lastElement = this.pagination.filter.length;
  }

  resetFilter() {
    this.employeesFilter = this.employees;
  }

  filter() {
    // const searchTerm = event.target.value.toLowerCase();
    // this.employeesFilter = this.employees.filter(employee =>
    //   employee.nombre.toLowerCase().includes(searchTerm) ||
    //   employee.identificacion.toLowerCase().includes(searchTerm) ||
    //   employee.correo.toLowerCase().includes(searchTerm)
    // );

    // this.pagination.total = result;
    // this.pagination.pageIndex = 0;
    // this.pagination.startElement = 0;
    // this.pagination.filter = result.slice(0, this.pagination.pageSize);
    // this.pagination.lastElement = this.pagination.filter.length;
  }

  deleteEmployee(invoice: any) {
    this.waitingFor = invoice;
    this.seeEmployeeTermination = false;
    this.terminationDate = new Date().toISOString().split('T')[0];
  }

  showDeleteQuestion(employee: any) {
    this.waitingFor = employee;
    this.seeEmployeeTermination = true;
    this.terminationDate = new Date().toISOString().split('T')[0];
  }

  confirmDelete(employee: EmployeeResponse) {
      if (!this.terminationDate) {
        this.toastService.warning('Debe seleccionar una fecha de baja', 'Aviso');
        return;
      }

      if (this.deleting[employee.id]) {
        return;
      }
      this.deleting[employee.id] = true;
      this.waitingFor = null;
      this.humanResourcesService.fireEmployees(employee.id, this.terminationDate).subscribe({
      next: (response: any) => {
        this.toastService.success('Empleado despedido con exito', 'Exito');
        this.deleting = {};
        this.getEmployees();
      },
      error: (error) => {
        this.toastService.error('Error al despedir el empleado', 'Error');
        this.deleting = {};
      }
    });
    }

  resetDeletingDiv() {
    this.waitingFor = null;
  }

  openUpdateContract(item: any) {
    this.employeeToUpdateContract = item;
    this.updatingContract = true;

    this.selectedProfile = null;
    this.selectedPosition = item?.position?.id || null;
  }

  cancelUpdateContract() {
    this.updatingContract = false;
    this.updatingContractEmployee = false;

    this.employeeToUpdateContract = null;
    this.selectedProfile = null;
    this.selectedPosition = null;

    this.createProfileSalary = false;
    this.newSalary = null;
  }

  showActualProfileSalary() {
    if (!this.selectedProfile) {
      this.toastService.warning('Debe seleccionar un perfil', 'Advertencia');
      return;
    }

    const profile = this.contractProfiles.find((p: any) => {
      return p.id + '' === this.selectedProfile + '';
    });

    if (!profile) {
      this.toastService.warning('No se encontró el perfil seleccionado', 'Advertencia');
      return;
    }

    profile['isPro'] = !!profile.proAmount;
    profile['isBonus'] = !!profile.bonusAmount;
    profile['isRelation'] = !!profile.relationAmount;

    this.createProfileSalary = false;
    this.newSalary = profile;
  }

  closeModalProfileSalary(value: number) {
    this.createProfileSalary = false;
    this.newSalary = null;

    if (value && value !== -1) {
      this.setProfileContracts(value);
    }
  }

  updateContract() {
    if (!this.employeeToUpdateContract) {
      this.toastService.warning('Debe seleccionar un empleado', 'Advertencia');
      return;
    }

    if (!this.selectedProfile || !this.selectedPosition) {
      this.toastService.warning('Debe seleccionar perfil y posición', 'Advertencia');
      return;
    }

    const salary: any = this.contractProfiles.find((c: any) => {
      return c.id + '' === this.selectedProfile + '';
    });

    if (!salary) {
      this.toastService.warning('No se encontró el perfil seleccionado', 'Advertencia');
      return;
    }

    const employeeId = this.employeeToUpdateContract.employee?.id || this.employeeToUpdateContract.id;

    const request: any = {
      employees: [employeeId],
      position: this.selectedPosition,

      relationAmount: salary.relationAmount,
      proAmount: salary.proAmount,
      bonusAmount: salary.bonusAmount,

      rAguinaldo: salary.rAguinaldo,
      rBono: salary.rBono,
      rVacaciones: salary.rVacaciones,
      rIggs: salary.rIggs,

      pAguinaldo: salary.pAguinaldo,
      pBono: salary.pBono,
      pVacaciones: salary.pVacaciones,

      bAguinaldo: salary.bAguinaldo,
      bBono: salary.bBono,
      bVacaciones: salary.bVacaciones,

      type: salary.type,
      shift: salary.shift,
      payment: salary.payment
    };

    this.updatingContractEmployee = true;

    this.humanResourcesService.updateContractEmployee(request).subscribe({
      next: () => {
        this.toastService.success('Contrato actualizado con éxito', 'Éxito');
        this.cancelUpdateContract();
        this.getEmployees();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error?.message || 'Error al actualizar contrato', 'Error');
        this.updatingContractEmployee = false;
      }
    });
  }
}
